import React, { ReactNode } from "react";

export type PageModuleProps = {
  children: NonNullable<ReactNode>;
  className?: string;
};

const PageModule = ({ children, className }: PageModuleProps) => {
  return <section className={`page-module ${className}`}>{children}</section>;
};

export { PageModule };
